import React, { Suspense } from 'react'

type Props = {
  children: React.ReactElement
}

export const LazyLoad = ({ children }: Props) => (
  <Suspense fallback={<div />}>{children}</Suspense>
)

export default LazyLoad
